import {debounce} from "../application";
import confetti from 'canvas-confetti';

let lastVisitAction = null;

document.addEventListener("turbo:visit", function(event) {
  lastVisitAction = event.detail.action;
});

document.addEventListener("turbo:load", debounce(function() {
  const isQuickAnalyzePage = window.location.pathname.includes('/quick-analyze');
  const isRestoreVisit = lastVisitAction === "restore";

  if (document.getElementById("analysis_details") && !isQuickAnalyzePage && !isRestoreVisit) {
    confetti({
      particleCount: 100,
      spread: 70,
      origin: { y: 0.6 }
    });
  }
}, 250));